import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import drawerBgImg from "assets/images/drawer_bg.png"

import { ReactComponent as CloseSvg} from 'assets/svgs/drawer_close.svg'
import { ReactNode, useCallback, useEffect, useState } from "react"
import { AnimatePresence, motion } from "framer-motion"

interface Props {
    isOpen: boolean
    children: ReactNode
    duration?: number
    closeRandom?: number
    onClose: (closed: boolean) => void
}


const DrawerCom = ({children, isOpen, closeRandom = 0, onClose}: Props) => {
    const [open, setOpen] = useState(false)

    const closeWin = useCallback(() => {
        setOpen(false)
        setTimeout(() => {
            onClose(false)
        }, 1 * 1000);
    }, [onClose])

    useEffect(() => {
        if(isOpen) {
            setOpen(true)
        } else {
            closeWin()
        }
    }, [closeWin, isOpen])

    useEffect(() => {
        if(closeRandom > 0) {
            closeWin()
        }
    }, [closeRandom, closeWin])

    useEffect(() => {
        if(open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "scroll"
        }
    }, [open])

    return <DrawerWrap>
        <DrawerMaskWrap onClick={closeWin}></DrawerMaskWrap>
        <AnimatePresence>
            {
                open && <AnimateDrawerContentWrap
                    initial={{ right: "-100%" }}
                    animate={{ right: "0%" }}
                    exit={{ right: "-100%" }}
                    transition={{
                        duration: 0.5,
                    }}
                >
                    <CloseSvgWrap onClick={closeWin}></CloseSvgWrap>
                    {
                        children
                    }
                </AnimateDrawerContentWrap>
            }
        </AnimatePresence>
    </DrawerWrap>
}

const DrawerWrap = styled(StyledContainer)`
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;
    z-index: 95;
`

const DrawerMaskWrap = styled(StyledContainer)`
    position: absolute;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;
    z-index: 96;
    background-color: rgba(0, 0, 0, 0)
`

const DrawerContentWrap = styled.div`
    position: absolute;
    top: 0;
    right:0%;
    bottom: 0;
    z-index: 97;
    width: 40vw;
    background-color: ${({theme}) => theme.basicWhite};
    box-shadow: -4px 0px 88px -4px rgba(24, 39, 75, 0.14), -4px 0px 32px -6px rgba(24, 39, 75, 0.15);

    background-image: url(${drawerBgImg});
    background-position: top;
    background-repeat: no-repeat;
    background-size: contain;

    padding-top: 120px;
    box-sizing: border-box;
`

const AnimateDrawerContentWrap = styled(motion(DrawerContentWrap))``;

const CloseSvgWrap = styled(CloseSvg)`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`

export default DrawerCom